import { lazy } from 'react'

const ForgotPassword = lazy(() => import('./ForgotPassword'))

export { ForgotPassword }
